import { makeStyles } from '@material-ui/core'
import { UiProps } from './Type'

const useStyles = makeStyles((theme) => ({
  '@keyframes progressanimation': {
    '0%': {
      backgroundPosition: '100%',
    },
    '100%': {
      backgroundPosition: '0%',
    },
  },
  progressBar: {
    position: 'sticky',
    top: 0,
    left: 56,
    transform: 'translate3d(-56px, 0, 0)',
    width: 'calc(100% + 56px + 56px)',
    height: 10,
    overflow: 'hidden',
    zIndex: 999,
    [theme.breakpoints.down('sm')]: {
      background: theme.palette.primary.light,
      width: '100%',
      left: 0,
      transform: 'translate3d(0, 0, 0)',
    },
  },
  line: (props: UiProps) => ({
    width: props.size ? `${props.size}%` : 0,
    height: '100%',
    transition: 'all ease 0.5s',
    animation: `shineBackground 4s linear infinite`,
    borderTopRightRadius: props.size && props.size === '100' ? 0 : 8,
    borderBottomRightRadius: props.size && props.size === '100' ? 0 : 8,
    backgroundImage:
      'linear-gradient(90deg,#01237E,#275DA9 17%,#4D98D4 34%,#73D2FF 51%,#01237E 68%,#275DA9 85%,#4D98D4)',
    backgroundSize: '300% 100%',
  }),
}))

export default useStyles
